(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('.d12').forEach(wrapper => {
      if (wrapper.dataset.enhanced) return;
      wrapper.dataset.enhanced = 'true';
      const feature = wrapper.querySelector('[data-d12-featured]');
      if (feature) {
        const panels = [...feature.querySelectorAll('[data-d12-panel]')];
        const picks = [...feature.querySelectorAll('[data-d12-pick]')];
        const choose = i => { panels.forEach((p,j) => p.hidden = j !== i); picks.forEach((p,j) => p.setAttribute('aria-pressed', String(j === i))); };
        picks.forEach((p,i) => p.addEventListener('click', () => choose(i))); choose(0);
      }
      const needs = wrapper.querySelector('[data-d12-needs]');
      if (needs) {
        const panels = [...needs.querySelectorAll('[data-d12-need-panel]')];
        const picks = [...needs.querySelectorAll('[data-d12-need]')];
        const choose = i => { panels.forEach((p,j) => p.hidden = j !== i); picks.forEach((p,j) => {p.setAttribute('aria-pressed', String(i === j)); p.classList.toggle('active',i === j);}); };
        picks.forEach((p,i) => p.addEventListener('click', () => choose(i))); choose(0);
      }
      wrapper.querySelectorAll('[data-d12-variant]').forEach(select => select.addEventListener('change', () => {
        select.closest('.product-card').querySelector('[data-d12-price]').textContent = select.selectedOptions[0].dataset.price;
      }));
      wrapper.querySelectorAll('[data-d12-zoom]').forEach(button => button.addEventListener('click', () => {
        const expanded = button.closest('[data-d12-inspection]').classList.toggle('zoom'); button.setAttribute('aria-pressed',String(expanded));
      }));
      wrapper.querySelectorAll('[data-d12-photo]').forEach(button => button.addEventListener('click', () => {
        const image = wrapper.querySelector('[data-d12-inspection] img'); image.src = button.dataset.d12Photo; image.removeAttribute('srcset');
        wrapper.querySelectorAll('[data-d12-photo]').forEach(b => b.setAttribute('aria-pressed',String(b === button)));
      }));
    });
  };
  initialize(); document.addEventListener('shopify:section:load', event => initialize(event.target));
  const selected = new Map();
  const tray = document.querySelector('[data-d12-tray]'); const dialog = document.querySelector('[data-d12-dialog]');
  if (!tray || !dialog) return;
  const status = tray.querySelector('[data-d12-status]'); const open = tray.querySelector('[data-d12-open]');
  const update = () => {
    tray.hidden = selected.size === 0; status.textContent = selected.size + ' / 2'; open.disabled = selected.size !== 2;
    document.querySelectorAll('[data-d12-compare]').forEach(input => input.checked = selected.has(input.closest('[data-d12-product]').dataset.d12Product));
  };
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-d12-compare]')) return;
    const input = event.target, card = input.closest('[data-d12-product]'), key = card.dataset.d12Product;
    if (input.checked && selected.size < 2) selected.set(key, card); else if (!input.checked) selected.delete(key); else input.checked = false;
    update();
  });
  tray.querySelector('[data-d12-clear]').addEventListener('click', () => {selected.clear();update();});
  let opener;
  open.addEventListener('click', () => {
    const cells = dialog.querySelectorAll('[data-d12-compare-cell]');
    [...selected.values()].forEach((card,i) => {
      cells[i].replaceChildren();
      const image = card.querySelector('.product-image img')?.cloneNode(); if(image) cells[i].append(image);
      const link = card.querySelector('h3 a').cloneNode(true); cells[i].append(link);
      const price = document.createElement('p');price.textContent = card.querySelector('[data-d12-price]').textContent;cells[i].append(price);
    });
    opener = document.activeElement;dialog.showModal();
  });
  dialog.querySelector('[data-d12-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => opener?.focus());
})();
